import React, { useContext, useEffect, useState } from "react";
import "./merchants.css";
import { NavLink } from "react-router-dom";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { IoIosDoneAll } from "react-icons/io";
import { CiLocationOn } from "react-icons/ci";
import Location from "../../Location";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import configContext from "../../context/configContext/configContext";

const Merchants = () => {
  document.title = "Merchants";
  const [data, setData] = useState([]);
  const [admindata, setAdminData] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [adminindustry, setAdminIndustry] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  // const food = [
  //   {
  //     id: 1,
  //     food_name: "Hotel Sri Jai Palace",
  //     img: "https://content.jdmagicbox.com/comp/nashik/d3/0253px253.x253.120523172614.p2d3/catalogue/hi-5-hotel-and-experience-pathardi-phata-nashik-4-star-hotels-htxxqb6760.jpg",
  //     desc: "",
  //     address: "Vidya Vikas Circle, Nashik",
  //   },
  //   {
  //     id: 2,
  //     food_name: "Dr. Ahers Dental Care",
  //     img: "https://www.myicsorg.net/wp-content/uploads/2022/11/Rectangle-760.png",
  //     desc: "",
  //     address: "Gangapur Road, Nashik",
  //   },
  //   {
  //     id: 3,
  //     food_name: "Dr. Avinash",
  //     img: "https://images1-fabric.practo.com/practices/1320170/white-crown-dentistry-nashik-601939f23d320.jpeg",
  //     desc: "",
  //     address:
  //       "Mukti Dham Road, Nashik Road, Nashik - 422101 (Near Railway Station)",
  //   },
  //   {
  //     id: 4,
  //     food_name: "Udupi Tadkas Gokul Pure Veg Family Restaurant",
  //     img: "https://www.intermiles.com/iwov-resources/images/blog/10-best-treks-to-do-in-march/top-5-luxurious-resorts-in-nashik-Twitter.jpg",
  //     desc: "",
  //     address: "Satpur, Trimbak Road, Satpur, Nashik - 422007",
  //   },
  //   {
  //     id: 5,
  //     food_name: "Udupi Tadkas Gokul Pure Veg Family Restaurant",
  //     img: "https://images.theconversation.com/files/368263/original/file-20201109-22-lqiq5c.jpg?ixlib=rb-1.1.0&rect=10%2C0%2C6699%2C4476&q=45&auto=format&w=926&fit=clip",
  //     desc: "",
  //     address: "Gole Colony, Nashik",
  //   },
  //   {
  //     id: 6,
  //     food_name: "Chaudhari Restorants",
  //     img: "https://imgcy.trivago.com/c_limit,d_dummy.jpeg,f_auto,h_600,q_auto,w_600//hotelier-images/73/ba/a5d44ac3b0d0ceeb413d8848f3d43c3ff4555a431086abcad357a61f88ef.jpeg",
  //     desc: "",
  //     address: "Gangapur Road",
  //   },
  //   {
  //     id: 7,
  //     food_name: "Sanket Classes",
  //     img: "https://franchiseindia.s3.ap-south-1.amazonaws.com/uploads/content/edu/art/open-uri20170217-14448-gojb-642aa5ced7.jpg",
  //     desc: "",
  //     address: "Gangapur Savargaon Road, Gangapur Road, Nashik - 422002",
  //   },
  //   {
  //     id: 8,
  //     food_name: "Inspire Academy",
  //     img: "https://www.quantumworkplace.com/hubfs/Marketing/Website/Blog/Blog%20Images/Employee%20Coaching.jpg",
  //     desc: "",
  //     address:
  //       "Gole Colony Gangapur Road Nashik., Gole Colony, Nashik - 422002",
  //   },
  // ];

  useEffect(() => {
    getMerchantData();
    getSuperAdminData();
    getIndustryData();
    getAdminIndustryData();
  }, []);

  const getMerchantData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/shopdetails/getallshop_details", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // Get
  const getSuperAdminData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/excel/getallmerchant_details", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setAdminData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // Get
  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/orgdetails/getallorg_details", {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustry(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  //   // Get
  const getAdminIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/adminorganization/getallorg_details", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setAdminIndustry(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/shopdetails/searchshop_details?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setAdminData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/shopdetails/searchshop_details?search=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setAdminData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterIndustryData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/register/searchorganization?search=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustry(response.data);
          setData(response.data);
          setAdminData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <div>
        <div className="p-5 merchant">
          <h3 className="text-center text-white">Search Anything...</h3>
        </div>
      </div>

      <div className="container-xl">
        <div className=" row my-3">
          <div className="col-md-4 text-end my-1">
            <select
              className="form-control text-uppercase"
              name=""
              id=""
              onChange={(e) => FilterData(e)} // Pass the event to FilterData
            >
              <option>All </option>
              <option value="gym">Gyms</option>
              <option value="cafe">Cafe's</option>
              <option value="lodge">Lodge</option>
              <option value="bakery">Bakery</option>
              <option value="classes">Classes</option>
              <option value="liabrary">Library</option>
              <option value="travel">Travels</option>
              <option value="loundry">Laundry</option>
              <option value="garage">Garage</option>
              <option value="medical">Medicals</option>
              <option value="restaurants">Restaurants</option>
              <option value="stationery">Stationery</option>
              <option value="cyber_cafe">Cyber Cafe</option>
              <option value="event_decors">Event Decors</option>
              <option value="pg/hostels">PG/Hostels</option>

              <option value="mobileshops">Mobile Shops</option>
              <option value="doctor/clinic">Doctors/Clinic</option>
              <option value="salon/parlor">Salons/Parlours</option>
              <option value="mess/parcel">Mess/Parcel Points</option>
              <option value="opticalstore">Optical Store</option>
              <option value="computer_hardware">
                Computer & Hardware Accessories
              </option>
            </select>
          </div>

          <div className="col-md-4 text-start my-1">
            <select
              className="form-control text-uppercase"
              name=""
              id=""
              onChange={(e) => FilterIndustryData(e)} // Pass the event to FilterData
            >
              <option>All </option>
              <option value="nonprofit">Nonprofit </option>
              <option value="government">Government</option>
              <option value="business">Business</option>
              <option value="consultant">Consultant</option>
              <option value="recruiter">Recruiter</option>
              <option value="community group/association">
                Association/Community Group
              </option>
            </select>
          </div>

          <div className="col-md-4">
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
        </div>

        <div className="row ">
          {data &&
            data?.map((item) => {
              return (
                <>
                  {item.status === "Approved" ? (
                    <NavLink
                      to={`/merchants/${item.id}`}
                      className="col-md-4 my-3 text-center text-decoration-none text-dark"
                      key={item.id}
                    >
                      <div className="shadow">
                        <img
                          className="rounded-3 card-img-top"
                          height={250}
                          src={item.image}
                          alt=""
                        />
                        <div className="p-3">
                          <p className="mt-2 text-start fw-bold">
                            {item.shop_name}
                          </p>
                          <p className="text-start">
                            <CiLocationOn /> {item.address}
                          </p>
                          {/* Ratings and Reviews Section */}
                          <div className="row align-items-center mt-3">
                            <div className="col-md-5 text-start">
                              <div className="d-flex align-items-center">
                                <div className="average-rating">
                                  {item.average_rating} &nbsp;
                                </div>
                                <div className="star-icons">
                                  {[1, 2, 3, 4, 5].map((star) => (
                                    <AiFillStar
                                      key={star}
                                      className={
                                        star <= item.average_rating
                                          ? "filled-star text-warning"
                                          : ""
                                      }
                                    />
                                  ))}
                                </div>
                              </div>
                              <div className="total-reviews">
                                {item.total_ratings} reviews
                              </div>
                            </div>
                            <div className="col-md-6 ">
                              <span className="bg-success text-white rounded-3 p-1">
                                <IoIosDoneAll className="fs-4" />
                                Verified
                              </span>
                            </div>
                          </div>
                          <div className="btn  banner w-25 mt-1 btn-sm me-2">
                            {/* <NavLink
                          to={`/merchants/${item.id}`}
                          className="text-decoration-none text-white"
                        > */}
                            <a
                              href="tel:+9371001138 "
                              className="text-decoration-none text-white"
                            >
                              Call
                            </a>
                            {/* </NavLink> */}
                          </div>
                          <div className="btn banner w-25 mt-1  btn-sm  me-2">
                            <a
                              className="text-decoration-none text-white"
                              href={item.location}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {/* <CiLocationOn /> */}
                              Direction
                            </a>
                          </div>
                          <div className="btn banner w-25 mt-1  btn-sm ">
                            <NavLink
                              to={`/merchants/${item.id}`}
                              className="text-decoration-none text-white"
                            >
                              Detail
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </NavLink>
                  ) : (
                    ""
                  )}
                </>
              );
            })}
          {admindata &&
            admindata?.map((item) => {
              return (
                <>
                  <NavLink
                    to={`/adminmerchants/${item.id}`}
                    className="col-md-4 my-3 text-center text-decoration-none text-dark"
                    key={item.id}
                  >
                    <div className="shadow">
                      <img
                        className="rounded-3 card-img-top"
                        height={250}
                        src={item.image}
                        alt=""
                      />
                      <div className="p-3">
                        <p className="mt-2 text-start fw-bold">
                          {item.shop_name}
                        </p>
                        <p className="text-start">
                          <CiLocationOn /> {item.address}
                        </p>
                        {/* Ratings and Reviews Section */}
                        <div className="row align-items-center mt-3">
                          <div className="col-md-4 text-start">
                            <div className="d-flex align-items-center">
                              <div className="average-rating">
                                {item.average_rating} &nbsp;
                              </div>
                              <div className="star-icons">
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <AiFillStar
                                    key={star}
                                    className={
                                      star <= item.average_rating
                                        ? "filled-star text-warning"
                                        : ""
                                    }
                                  />
                                ))}
                              </div>
                            </div>
                            <div className="total-reviews">
                              {item.total_ratings} reviews
                            </div>
                          </div>
                          <div className="col-md-6 text-end">
                            <span className="bg-success text-white rounded-3  p-1">
                              <IoIosDoneAll className="fs-4" />
                              Verified
                            </span>
                          </div>
                        </div>
                        <div className="btn  banner w-25 mt-1 btn-sm me-2">
                          {/* <NavLink
                          to={`/merchants/${item.id}`}
                          className="text-decoration-none text-white"
                        > */}
                          <a
                            href="tel:+9371001138 "
                            className="text-decoration-none text-white"
                          >
                            Call
                          </a>
                          {/* </NavLink> */}
                        </div>
                        <div className="btn banner w-25 mt-1  btn-sm  me-2">
                          <a
                            className="text-decoration-none text-white"
                            href={item.location}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {/* <CiLocationOn /> */}
                            Direction
                          </a>
                        </div>
                        <div className="btn banner w-25 mt-1  btn-sm ">
                          <NavLink
                            to={`/adminmerchants/${item.id}`}
                            className="text-decoration-none text-white"
                          >
                            Detail
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </NavLink>
                </>
              );
            })}
          {industry.map((item) => {
            return (
              <>
                {item.status === "Approved" ? (
                  <NavLink
                    to={`/organization/${item.id}`}
                    className="col-md-4 my-3 text-center text-decoration-none text-dark"
                    key={item.id}
                  >
                    <div className="shadow">
                      <img
                        className="rounded-3 card-img-top"
                        height={250}
                        src={item.image}
                        alt=""
                      />
                      <div className="p-3">
                        <p className="mt-2 text-start fw-bold">
                          {item.business_name}
                        </p>
                        <p className="text-start">
                          <CiLocationOn /> {item.address}
                        </p>
                        {/* Ratings and Reviews Section */}
                        <div className="row align-items-center mt-3">
                          <div className="col-md-5 text-start">
                            <div className="d-flex align-items-center">
                              <div className="average-rating">
                                {item.average_rating} &nbsp;
                              </div>
                              <div className="star-icons">
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <AiFillStar
                                    key={star}
                                    className={
                                      star <= item.average_rating
                                        ? "filled-star text-warning"
                                        : ""
                                    }
                                  />
                                ))}
                              </div>
                            </div>
                            <div className="total-reviews">
                              {item.total_ratings} reviews
                            </div>
                          </div>
                          <div className="col-md-6 my-2">
                            <span className="bg-success text-white rounded-3 p-1">
                              <IoIosDoneAll className="fs-4" />
                              Verified
                            </span>
                          </div>
                        </div>
                        <div className="btn  banner w-25 mt-1 btn-sm me-2">
                          {/* <NavLink
                          to={`/merchants/${item.id}`}
                          className="text-decoration-none text-white"
                        > */}
                          <a
                            href="tel:+9371001138 "
                            className="text-decoration-none text-white"
                          >
                            Call
                          </a>
                          {/* </NavLink> */}
                        </div>
                        <div className="btn banner w-25 mt-1  btn-sm  me-2">
                          <a
                            className="text-decoration-none text-white"
                            href={item.location}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {/* <CiLocationOn /> */}
                            Direction
                          </a>
                        </div>
                        <div className="btn banner w-25 mt-1  btn-sm ">
                          <NavLink
                            to={`/organization/${item.id}`}
                            className="text-decoration-none text-white"
                          >
                            Detail
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </NavLink>
                ) : (
                  ""
                )}
              </>
            );
          })}
          {adminindustry.map((item) => {
            return (
              <>
                <NavLink
                  to={`/adminorganization/${item.id}`}
                  className="col-md-4 my-3 text-center text-decoration-none text-dark"
                  key={item.id}
                >
                  <div className="shadow">
                    <img
                      className="rounded-3 card-img-top"
                      height={250}
                      src={item.image}
                      alt=""
                    />
                    <div className="p-3">
                      <p className="mt-2 text-start fw-bold">
                        {item.business_name}
                      </p>
                      <p className="text-start">
                        <CiLocationOn /> {item.address}
                      </p>
                      {/* Ratings and Reviews Section */}
                      <div className="row align-items-center mt-3">
                        <div className="col-md-5 text-start">
                          <div className="d-flex align-items-center">
                            <div className="average-rating">
                              {item.average_rating} &nbsp;
                            </div>
                            <div className="star-icons">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <AiFillStar
                                  key={star}
                                  className={
                                    star <= item.average_rating
                                      ? "filled-star text-warning"
                                      : ""
                                  }
                                />
                              ))}
                            </div>
                          </div>
                          <div className="total-reviews">
                            {item.total_ratings} reviews
                          </div>
                        </div>
                        <div className="col-md-6 my-2">
                          <span className="bg-success text-white rounded-3 p-1">
                            <IoIosDoneAll className="fs-4" />
                            Verified
                          </span>
                        </div>
                      </div>
                      <div className="btn  banner w-25 mt-1 btn-sm me-2">
                        {/* <NavLink
                          to={`/merchants/${item.id}`}
                          className="text-decoration-none text-white"
                        > */}
                        <a
                          href="tel:+9371001138 "
                          className="text-decoration-none text-white"
                        >
                          Call
                        </a>
                        {/* </NavLink> */}
                      </div>
                      <div className="btn banner w-25 mt-1  btn-sm  me-2">
                        <a
                          className="text-decoration-none text-white"
                          href={item.location}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {/* <CiLocationOn /> */}
                          Direction
                        </a>
                      </div>
                      <div className="btn banner w-25 mt-1  btn-sm ">
                        <NavLink
                          to={`/adminorganization/${item.id}`}
                          className="text-decoration-none text-white"
                        >
                          Detail
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </NavLink>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Merchants;
